<div #outerContainer class="outer-container">
  <img #thumbnailPreview [src]="image" alt="thumbnail preview" class="thumbnail-preview" />
  <div #canvas class="canvas" class="canvas" (click)="onCanvasClicked($event)">
    <div #annotation class="annotation"></div>
  </div>
</div>